<div class="db-informative-dialog">
  <div class="db-informative-dialog-left-side">
    <h2 class="db-informative-dialog-left-side-title mb10" *ngIf="title" [innerHTML]="title"></h2>
    <p class="db-informative-dialog-left-side-description" *ngIf="description" [innerHTML]="description"></p>
    <ng-container *ngIf="features">
      <div class="db-informative-dialog-left-side-features mt20">
        <div class="db-informative-dialog-left-side-feature" *ngFor="let feature of features">
          <i *ngIf="feature.icon" class="db-icon {{feature.icon}}" [ngStyle]="{color: feature.iconColor}"></i>
          <span [innerHTML]="feature.text"></span>
        </div>
      </div>
    </ng-container>

    <button class="mt30 {{button.size}} {{button.color}} {{button.class}}"  (click)="close()">
      <span [innerHTML]="button.text"></span>
    </button>
  </div>
  <div class="db-informative-dialog-right-side" *ngIf="rightImage">
    <img [src]="rightImage"/>
  </div>
</div>
